{
  "version": 1,
  "asset_id": "ba99cfb2-cb5a-4e8e-b920-0b83ec7dbf0d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/ba99cfb2-cb5a-4e8e-b920-0b83ec7dbf0d/svc-saas-seo-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/ba99cfb2-cb5a-4e8e-b920-0b83ec7dbf0d/svc-saas-seo-1200.avif",
  "original_filename": "svc-saas-seo-1200.avif",
  "size": 14081,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:58Z"
}
